import { BookmarksView } from '@/views/Bookmarks/Bookmarks.view';
import { withPreRenderSettings } from '@/utils/hocs';
import { getSeoFullData } from '@/api/helpers/seo.helpers';
import NoSsr from '@/components/NoSsr/NoSsr';

function BookmarksPage() {
  return (
    <NoSsr>
      <BookmarksView />
    </NoSsr>
  );
}

BookmarksPage.getInitialProps = withPreRenderSettings(
  async (context, client) => {
    const seoFullData = await getSeoFullData(client, context);

    return { seoFullData: seoFullData ?? null };
  }
);

export default BookmarksPage;
